export default __webpack_public_path__ + "static/banner-7d132a9c4c320512f9d5b2cbdfed3573.jpg";